import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Data } from '@/types';

import { PendingNotification } from '../types';

export const getPendingNotifications = (): Promise<Data<PendingNotification[]>> =>
  axios.get(`/client/notifications`);

type QueryFnType = typeof getPendingNotifications;

type UsePendingNotificationsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const usePendingNotifications = ({ config }: UsePendingNotificationsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['pending-notifications'],
    queryFn: () => getPendingNotifications(),
  });
};
